module.exports = __webpack_public_path__ + "static/media/ellam-selected.53620303.png";